// Nuevo módulo en Angular para instanciar los componentes que tiene el módulo de vacaciones.
// Se importa en app.module.ts

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { RouterModule } from "@angular/router";
import { SharedModule } from "../../../shared/shared.module";
import { AsuntosPropiosComponent } from "./asuntos-propios.component";
import { AsuntosPropiosFormComponent, RechazarAsuntosPropiosComponent, ValidarAsuntosPropiosComponent } from "./asuntos-propios-form.component";

@NgModule({
    declarations: [
        AsuntosPropiosComponent,
        AsuntosPropiosFormComponent,
        ValidarAsuntosPropiosComponent,
        RechazarAsuntosPropiosComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatTableModule,
        MatTabsModule,
        MatSelectModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatDividerModule,
        MatDatepickerModule,
        MatCardModule,
        SharedModule,
    ],
    providers: []
})
export class AsuntosPropiosModule { }
